import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCard,
    { staticClass: "full-width" },
    [
      _c(
        VDataTable,
        _vm._g(
          _vm._b(
            {
              attrs: {
                headers: _vm._cols,
                items: _vm.rows,
                options: _vm._options,
                "server-items-length": _vm._total,
              },
              on: {
                "update:options": function ($event) {
                  _vm._options = $event
                },
              },
              scopedSlots: _vm._u(
                [
                  _vm._l(_vm._colHeaderSlots, function (header) {
                    return {
                      key: `header.${header.value}`,
                      fn: function ({ item }) {
                        return [
                          _vm._t(
                            "header_" + header.value,
                            function () {
                              return [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(header.text) +
                                    "\n      "
                                ),
                              ]
                            },
                            { item: item }
                          ),
                        ]
                      },
                    }
                  }),
                  _vm._l(_vm._colItemSlots, function (header) {
                    return {
                      key: `item.${header.value}`,
                      fn: function ({ item }) {
                        return [
                          _vm._t(
                            "item_" + header.value,
                            function () {
                              return [
                                !header.type
                                  ? _c("div", { key: "item_" + header.value }, [
                                      _vm._v(
                                        "\n          " +
                                          _vm._s(item[header.value]) +
                                          "\n        "
                                      ),
                                    ])
                                  : _c(
                                      "d-warp",
                                      _vm._b(
                                        {
                                          key: "item_" + header.value,
                                          attrs: { value: item[header.value] },
                                        },
                                        "d-warp",
                                        header,
                                        false
                                      )
                                    ),
                              ]
                            },
                            { item: item }
                          ),
                        ]
                      },
                    }
                  }),
                  {
                    key: "expanded-item",
                    fn: function (data) {
                      return [
                        _c(
                          "td",
                          { attrs: { colspan: data.headers.length } },
                          [_vm._t("expanded_item", null, null, data)],
                          2
                        ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            },
            "v-data-table",
            { ..._vm.defaultProps, ..._vm.$attrs },
            false
          ),
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }